import React from "react";
import * as GroupGameService from "../../api/GroupGameService";
import style from "./SideBar.module.css";
import Dice6 from "../../image/tmp-png/dice-6.png";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

export default function HistoryRowPendingMoves(props) {
    function deleteLastMove() {
        GroupGameService.deleteLastPendingMove(props.gameId, props.selectedPlayer.id, () => {}, () => {
            window.alert("Не вдалось видалити крок")
        })
    }

    return <div className={style.pendingMovesContainer}>
        <div className={style.pendingMovesTitle}>Очікують наступного кидка</div>
        <div className={style.pendingMovesDicesContainer}>
            {props.selectedPlayer.pending_moves.map((element, index) => {
                return <div style={{display: "flex", flexDirection: "row"}}>
                    <div className={style.pending6} style={{backgroundImage: "url(" + Dice6 + ")"}}/>
                    {index === props.selectedPlayer.pending_moves.length - 1 && props.is_mentor &&
                        <OverlayTrigger
                            placement="top"
                            delay={{show: 400, hide: 50}}
                            overlay={<Tooltip id="button-tooltip">Видалити останній</Tooltip>}
                        >
                            <div className={style.deletePendingMoveBtn} onClick={deleteLastMove}>X</div>
                        </OverlayTrigger>}
                </div>
            })}

        </div>
    </div>

}